import React, { FC } from 'react'
import { theme, FontSizeProps, ColorProps } from '../../../theme'

export const Copy: FC<{
  color?: ColorProps
  size?: FontSizeProps
}> = ({ color, size }) => {
  return (
    <svg
      width={theme.fontSizes[size!]}
      height={theme.fontSizes[size!]}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6443 2.11677L10.1919 0.700104C9.9642 0.465683 9.79523 0.333986 9.47318 0.333984L5.21424 0.333984C4.54361 0.333984 3.99996 0.89362 3.99996 1.58398V3.00065H1.88091C1.21027 3.00065 0.666626 3.56029 0.666626 4.25065V12.4173C0.666626 13.1077 1.21027 13.6673 1.88091 13.6673H7.33329C8.00393 13.6673 8.66663 13.1077 8.66663 12.4173V11.0007H10.6666C11.3373 11.0007 12 10.3577 12 9.66732V3.00065C12 2.66913 11.872 2.35119 11.6443 2.11677ZM7.18151 12.334H2.15174C2.11149 12.334 2.07288 12.3175 2.04442 12.2882C2.01595 12.2589 1.99996 12.2192 1.99996 12.1777V4.49023C1.99996 4.44879 2.01595 4.40905 2.04442 4.37975C2.07288 4.35045 2.11149 4.33398 2.15174 4.33398H3.99996V9.75065C3.99996 10.441 4.54361 11.0007 5.21424 11.0007H7.33329V12.1777C7.33329 12.2192 7.3173 12.2589 7.28884 12.2882C7.26037 12.3175 7.22176 12.334 7.18151 12.334ZM10.5148 9.66732H5.48508C5.44482 9.66732 5.40621 9.65086 5.37775 9.62155C5.34928 9.59225 5.33329 9.55251 5.33329 9.51107V1.82357C5.33329 1.78213 5.34928 1.74238 5.37775 1.71308C5.40621 1.68378 5.44482 1.66732 5.48508 1.66732H7.99996V3.66732C7.99996 4.00065 8.33329 4.33398 8.6071 4.33398H10.6666V9.51107C10.6666 9.41732 10.6506 9.59225 10.6222 9.62155C10.5937 9.65086 10.5551 9.66732 10.5148 9.66732ZM10.6666 3.00065H9.33329V1.66732H9.57696C9.61721 1.66732 9.65581 1.68378 9.6843 1.71307L10.6222 2.63932C10.6363 2.65383 10.6475 2.67106 10.6551 2.69002C10.6627 2.70898 10.6666 2.7293 10.6666 2.74982V3.00065Z"
        fill={theme.colors[color!]}
      />
    </svg>
  )
}

Copy.defaultProps = {
  color: 'success',
  size: 'x2',
}
